import { render, staticRenderFns } from "./Asignacionesv2pro.vue?vue&type=template&id=b0201d20"
import script from "./Asignacionesv2pro.vue?vue&type=script&lang=js"
export * from "./Asignacionesv2pro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports